import React from 'react';
import { Clock, Coffee, AlertCircle } from 'lucide-react';

const TimeSettingsSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900 dark:text-white">Настройки времени</h3>
      
      {/* Временные границы учебного дня */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="dayStartTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-indigo-500" />
            Начало учебного дня
          </label>
          <input
            type="time"
            id="dayStartTime"
            name="dayStartTime"
            value={formData.dayStartTime}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.dayStartTime ? 'input-error' : ''}`}
          />
          {errors.dayStartTime && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.dayStartTime}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="dayEndTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-indigo-500" />
            Окончание учебного дня
          </label>
          <input
            type="time"
            id="dayEndTime"
            name="dayEndTime"
            value={formData.dayEndTime}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.dayEndTime ? 'input-error' : ''}`}
          />
          {errors.dayEndTime && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.dayEndTime}
            </p>
          )}
        </div>
      </div>

      {/* Обеденный перерыв */}
      <div>
        <div className="flex items-center mb-2">
          <input
            type="checkbox"
            id="lunchBreak"
            name="lunchBreak"
            checked={formData.lunchBreak}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <label htmlFor="lunchBreak" className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center">
            <Coffee className="w-4 h-4 mr-1 text-orange-500" />
            Учитывать обеденный перерыв
          </label>
        </div>
        
        {formData.lunchBreak && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
            <div>
              <label htmlFor="lunchStartTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Начало обеда
              </label>
              <input
                type="time"
                id="lunchStartTime"
                name="lunchStartTime"
                value={formData.lunchStartTime}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.lunchStartTime ? 'input-error' : ''}`}
              />
              {errors.lunchStartTime && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.lunchStartTime}
                </p>
              )}
            </div>

            <div>
              <label htmlFor="lunchDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Длительность обеда (мин)
              </label>
              <input
                type="number"
                id="lunchDuration"
                name="lunchDuration"
                min="15"
                max="120"
                value={formData.lunchDuration}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.lunchDuration ? 'input-error' : ''}`}
              />
              {errors.lunchDuration && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.lunchDuration}
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Параметры занятий */}
      <div className="bg-gray-50 dark:bg-gray-700/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <h4 className="text-base font-medium text-gray-800 dark:text-gray-200 mb-3">Параметры занятий</h4>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="eventDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Длительность занятия (мин)
            </label>
            <input
              type="number"
              id="eventDuration"
              name="eventDuration"
              min="15"
              max="180"
              value={formData.eventDuration}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.eventDuration ? 'input-error' : ''}`}
            />
            {errors.eventDuration && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.eventDuration}
              </p>
            )}
          </div>

          <div>
            <label htmlFor="breakDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Длительность перерыва (мин)
            </label>
            <input
              type="number"
              id="breakDuration"
              name="breakDuration"
              min="5"
              max="30"
              value={formData.breakDuration}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.breakDuration ? 'input-error' : ''}`}
            />
            {errors.breakDuration && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.breakDuration}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* Типовые расписания звонков */}
      <div>
        <div className="flex justify-between items-center mb-2">
          <h4 className="text-base font-medium text-gray-800 dark:text-gray-200">
            Типовые расписания звонков
          </h4>
          <button 
            type="button"
            className="text-sm text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300"
            onClick={() => {
              // Здесь будет логика применения типового расписания
              alert('Выбранное расписание звонков будет применено к текущим настройкам.');
            }}
          >
            Применить выбранное
          </button>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          <button
            type="button"
            className="text-left p-3 rounded border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            onClick={() => {
              // Применение школьного расписания
              handleInputChange({
                target: {
                  name: 'dayStartTime',
                  value: '08:30'
                }
              });
              handleInputChange({
                target: {
                  name: 'dayEndTime',
                  value: '15:00'
                }
              });
              handleInputChange({
                target: {
                  name: 'eventDuration',
                  value: '45'
                }
              });
              handleInputChange({
                target: {
                  name: 'breakDuration',
                  value: '10'
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchBreak',
                  value: true
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchStartTime',
                  value: '11:50'
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchDuration',
                  value: '30'
                }
              });
            }}
          >
            <div className="font-medium">Школьное</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              8:30 - 15:00, уроки по 45 мин
            </div>
          </button>
          
          <button
            type="button"
            className="text-left p-3 rounded border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            onClick={() => {
              // Применение университетского расписания
              handleInputChange({
                target: {
                  name: 'dayStartTime',
                  value: '09:00'
                }
              });
              handleInputChange({
                target: {
                  name: 'dayEndTime',
                  value: '18:00'
                }
              });
              handleInputChange({
                target: {
                  name: 'eventDuration',
                  value: '90'
                }
              });
              handleInputChange({
                target: {
                  name: 'breakDuration',
                  value: '10'
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchBreak',
                  value: true
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchStartTime',
                  value: '13:00'
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchDuration',
                  value: '60'
                }
              });
            }}
          >
            <div className="font-medium">Университетское</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              9:00 - 18:00, пары по 90 мин
            </div>
          </button>
          
          <button
            type="button"
            className="text-left p-3 rounded border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            onClick={() => {
              // Применение вечернего расписания
              handleInputChange({
                target: {
                  name: 'dayStartTime',
                  value: '16:00'
                }
              });
              handleInputChange({
                target: {
                  name: 'dayEndTime',
                  value: '21:00'
                }
              });
              handleInputChange({
                target: {
                  name: 'eventDuration',
                  value: '60'
                }
              });
              handleInputChange({
                target: {
                  name: 'breakDuration',
                  value: '10'
                }
              });
              handleInputChange({
                target: {
                  name: 'lunchBreak',
                  value: false
                }
              });
            }}
          >
            <div className="font-medium">Вечернее</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              16:00 - 21:00, занятия по 60 мин
            </div>
          </button>
        </div>
      </div>

      {/* Уведомление */}
      <div className="bg-yellow-50 dark:bg-yellow-900/20 p-4 rounded-lg border border-yellow-100 dark:border-yellow-800">
        <div className="flex items-start">
          <AlertCircle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
              Важно для составления расписания
            </h4>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              Согласно СанПиН 2.4.2.2821-10, длительность уроков в российских школах не должна превышать 45 минут, 
              а для первых классов рекомендуется не более 35 минут. Для ВУЗов длительность пары обычно составляет 
              90 минут, включая короткий перерыв.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeSettingsSection;